module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue5.6ec8f18a.jpg";